@if (!loaded) {
  <div class="chart-skeleton">
    <svg
      class="chart-skeleton-svg"
      viewBox="0 0 600 290"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <!-- Gridlines -->
      <line x1="48" y1="30"  x2="592" y2="30"  class="grid-line"/>
      <line x1="48" y1="80"  x2="592" y2="80"  class="grid-line"/>
      <line x1="48" y1="130" x2="592" y2="130" class="grid-line"/>
      <line x1="48" y1="180" x2="592" y2="180" class="grid-line"/>
      <line x1="48" y1="230" x2="592" y2="230" class="grid-line"/>

      <!-- Y-axis label rects -->
      <rect x="2"  y="25"  width="38" height="8" rx="3" class="skel-rect"/>
      <rect x="2"  y="75"  width="38" height="8" rx="3" class="skel-rect"/>
      <rect x="2"  y="125" width="38" height="8" rx="3" class="skel-rect"/>
      <rect x="2"  y="175" width="38" height="8" rx="3" class="skel-rect"/>
      <rect x="2"  y="225" width="38" height="8" rx="3" class="skel-rect"/>

      <!-- X-axis label rects -->
      <rect x="50"  y="244" width="42" height="8" rx="3" class="skel-rect"/>
      <rect x="160" y="244" width="42" height="8" rx="3" class="skel-rect"/>
      <rect x="270" y="244" width="42" height="8" rx="3" class="skel-rect"/>
      <rect x="380" y="244" width="42" height="8" rx="3" class="skel-rect"/>
      <rect x="490" y="244" width="42" height="8" rx="3" class="skel-rect"/>

      <!-- Portfolio area fill -->
      <path
        class="skel-area"
        d="M50,215 C90,205 130,188 175,168
           S255,138 305,122
           S385,98 435,82
           S510,65 555,57 L592,54
           L592,230 L50,230 Z"
      />

      <!-- Portfolio line -->
      <path
        class="skel-line skel-line-portfolio"
        d="M50,215 C90,205 130,188 175,168
           S255,138 305,122
           S385,98 435,82
           S510,65 555,57 L592,54"
      />

      <!-- Benchmark line -->
      <path
        class="skel-line skel-line-bench"
        d="M50,215 C90,210 130,202 175,194
           S255,182 305,174
           S385,163 435,153
           S510,143 555,137 L592,134"
      />

      <!-- Range-selector button rects (top right) -->
      <rect x="400" y="265" width="24" height="14" rx="7" class="skel-rect skel-btn"/>
      <rect x="430" y="265" width="24" height="14" rx="7" class="skel-rect skel-btn"/>
      <rect x="460" y="265" width="24" height="14" rx="7" class="skel-rect skel-btn"/>
      <rect x="490" y="265" width="24" height="14" rx="7" class="skel-rect skel-btn"/>
      <rect x="520" y="265" width="30" height="14" rx="7" class="skel-rect skel-btn"/>
      <rect x="556" y="265" width="36" height="14" rx="7" class="skel-rect skel-btn"/>
    </svg>

    <!-- Legend row -->
    <div class="chart-skeleton-legend">
      <div class="legend-item">
        <div class="legend-line legend-line-portfolio"></div>
        <div class="legend-label"></div>
      </div>
      <div class="legend-item">
        <div class="legend-line legend-line-bench"></div>
        <div class="legend-label legend-label-short"></div>
      </div>
    </div>
  </div>
}
